import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { FloatingCartButton } from './components/FloatingCartButton';
import { Toaster } from './components/ui/sonner';
import { Home } from './pages/Home';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { Dashboard } from './pages/Dashboard';
import { AdminContacts } from './pages/AdminContacts';
import { AdminConsole } from './pages/AdminConsole';
import { TeamRandomizerWidget } from './pages/TeamRandomizerWidget';
import { TeamSpotOwnerWidget } from './pages/TeamSpotOwnerWidget';
import { CoinFlipMachine } from './pages/CoinFlipMachine';
import { Cart } from './pages/Cart';
import { Purchase } from './pages/Purchase';
import { PaymentSuccess } from './pages/PaymentSuccess';
import { Careers } from './pages/Careers';
import { HostedPage } from './pages/HostedPage';
import '@/App.css';
import '@/index.css';

// Standalone routes render the raw hosted HTML without any LAB21G chrome.
const STANDALONE_ROUTES = ['/scott'];

const AppShell = () => {
  const { pathname } = useLocation();
  const isStandalone = STANDALONE_ROUTES.includes(pathname);

  const routes = (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/widgets/team-randomizer" element={<TeamRandomizerWidget />} />
      <Route path="/widgets/team-spot-owner" element={<TeamSpotOwnerWidget />} />
      <Route path="/widgets/coin-flip-machine" element={<CoinFlipMachine />} />
      <Route path="/cart" element={<Cart />} />
      <Route path="/admin" element={<AdminConsole />} />
      <Route path="/admin/contacts" element={<AdminContacts />} />
      <Route path="/purchase/:widgetId" element={<Purchase />} />
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="/careers" element={<Careers />} />
      <Route path="/scott" element={<HostedPage slug="scott" title="Scott — LAB21G" />} />
    </Routes>
  );

  if (isStandalone) {
    // No chrome — hosted HTML fills the viewport 1:1.
    return <>{routes}<Toaster position="bottom-right" richColors theme="dark" /></>;
  }

  return (
    <div className="App min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">{routes}</main>
      <Footer />
      <FloatingCartButton />
      <Toaster position="bottom-right" richColors theme="dark" />
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <ScrollToTop />
          <AppShell />
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;